import { useState, useEffect, useRef } from "react";

import axios from "axios";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";

import { Modal, Button, Form, Row, Col, ToggleButton } from "react-bootstrap";
import { Toast } from "primereact/toast";

const EditUser = (props) => {
  const toast = useRef(null);
  const show = props.show;
  const setShow = props.setShow;
  const setCounter = props.setCounter;
  const counter = props.counter;
  const barber = props.barber;

  // console.table(barber);

  const [loading, setLoading] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user?.encrypted_id;

  // const {
  //   error,
  //   isLoading,
  //   data: barber,
  // } = useFetch(`${main_link}selectUser?user_id=${user_id}&edit_id=${edit_id}`);

  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [role, setRole] = useState("10");
  const [dob, setDob] = useState();
  const [address, setAddress] = useState();
  const [isDisabled, setIsDisabled] = useState();
  const [barberID, setBarberID] = useState();
  const [created_at, setCreated_at] = useState();
  const [created_from, setCreated_from] = useState();
  const [last_update, setLast_update] = useState();

  useEffect(() => {
    if (barber) {
      setName(barber.name || "");
      setPhone(barber.phone || "");
      setEmail(barber.email || "");
      setAddress(barber.address || "");
      setDob(barber.dob || "");
      setRole(barber.role || "");
      setCreated_at(barber.created_at_at || "");
      setCreated_from(barber.created_since || "");
      setLast_update(barber.updated_at_at || "");
      setIsDisabled(barber.isDisabled ? 1 : 0 || 0);
      setBarberID(barber.decryptedId);
    }
  }, [barber]);

  const save = async () => {
    setLoading(true);
    try {
      const response = await axios.post(main_link + "updateUser", {
        name,
        email,
        phone,
        address,
        password,
        dob,
        role,
        user_id,
        barberID,
      });

      setLoading(false);

      // console.log(response);

      if (response.data.message === "You Cant Edit Your Data from Here") {
        toast.current.show({
          severity: "info",
          summary: "info",
          detail: "You Cant Edit Your Data from Here.",
        });
        setShow(false);
        setCounter(counter + 1);
      }

      if (response.data.message === "Saved Successfully.") {
        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Saved Successfully.",
        });
        setShow(false);
        setCounter(counter + 1);
      }
      if (response.data.message == "No Changes Requested.") {
        toast.current.show({
          severity: "info",
          summary: "Info",
          detail: "No Changes Requested.",
        });
        setShow(false);
        setCounter(counter + 1);
      }
    } catch (error) {
      setLoading(false);
      let errorMessage = "";
      Object.values(error.response?.data?.errors || {}).forEach(
        (errorArray) => {
          errorArray.forEach((error) => {
            errorMessage += error + " ";
          });
        }
      );
      toast.current.show({
        severity: "error",
        summary: "error",
        detail: errorMessage,
      });
      // toast.error(<div dangerouslySetInnerHTML={{ __html: errorMessage }} />);
    }
  };

  const enable_disabled = async () => {
    // function to disable or enable user
    // console.log(edit_id);
    var answer = window.confirm(
      "Are you sure you want to " +
        (isDisabled == "1" ? "Enable" : "Disable") +
        " " +
        name
    );
    if (answer) {
      setIsDisabled(!isDisabled);

      if (isDisabled == "1") {
        setIsDisabled(0);
      }
      if (isDisabled == "0") {
        setIsDisabled(1);
      }

      try {
        const response = await axios.post(main_link + "enable_disabled_user", {
          user_id,
          barberID,
          isDisabled,
        });

        // console.log(response.data.message);

        if (response.data.message == "You Can't Enable/Disabled Your Self") {
          toast.current.show({
            severity: "info",
            summary: "info",
            detail: "You Can't Enable/Disabled Your Self",
          });
          setCounter(counter + 1);
        }

        if (response.data.message == "User Disabled Successfully.") {
          toast.current.show({
            severity: "success",
            summary: "success",
            detail: "User Disabled Successfully.",
          });
          setShow(false);
          setCounter(counter + 1);
        }
        if (response.data.message == "User Enabled Successfully.") {
          toast.current.show({
            severity: "success",
            summary: "success",
            detail: "User Enabled Successfully.",
          });
          setShow(false);
          setCounter(counter + 1);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton className="bg-primary">
          <Modal.Title>Edit User: {name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  defaultValue={barber.name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Email Address"
                  defaultValue={barber.email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Phone Number"
                  defaultValue={barber.phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  defaultValue="000000000000"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Role</Form.Label>
                <Form.Select
                  defaultValue={barber.role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="100">Admin</option>
                  <option value="10">Regular User</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <ToggleButton
                  className="mb-2"
                  id="toggle-check"
                  type="checkbox"
                  variant={isDisabled == "1" ? "danger" : "primary"}
                  checked={isDisabled}
                  value={isDisabled ? "1" : " "}
                  // onChange={(e) => setIsDisabled(e.currentTarget.checked)}
                  style={{
                    margin: "32px",
                    width: "80%",
                  }}
                  onClick={() => enable_disabled(barberID)}
                >
                  {isDisabled == "1" ? "Enable" : "Disable"}
                </ToggleButton>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Set Address"
                  defaultValue={barber.address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Birth Date</Form.Label>
                <Form.Control
                  type="date"
                  defaultValue={barber.dob}
                  onChange={(e) => setDob(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          {!loading && (
            <Button variant="primary" onClick={save}>
              Save
            </Button>
          )}
          {loading && (
            <Button variant="primary" disabled>
              Saving...
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditUser;
